import axios from 'axios'

const INDEX_NEW_GAME = 'INDEX_NEW_GAME'
const X_X_FL = 'X_X_FL'
const newGameState = {
	GameIndexList:{}
}

export function newGame(state=newGameState,action){
	
	switch(action.type){
		case INDEX_NEW_GAME:
			return{ 
				...state,
				GameIndexList:action.payload
			}
		case X_X_FL:
			return{ 
				...state,
				xxfl:action.payload
			}
		default:
			return state
	}
}

export function xxflStaus(data){
	
	return { type:X_X_FL, payload:data}
}

function newGameIndex(idata){
	
	
	return { type:INDEX_NEW_GAME,payload:idata}
}


export function getNewGameIndex(){

	return dispatch=>{

		axios.get('/fapi/index/recomgames?limt=5&page=3')

			.then(res=>{	
					
				//if (res.data.return_code==0) {
					console.log(res)
					dispatch(newGameIndex(res.data))
				//}

			})
		

	}
}


// WEBPACK FOOTER //
// ./src/redux/newGame.redux.js